module.exports = __webpack_public_path__ + "img/sendMail.97c34758.svg";